module.exports = __webpack_public_path__ + "static/img/1.af8c443.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/8/3/zh/1.png
// module id = RtUL
// module chunks = 0